import React, { useState } from "react";
import "../styles/AddPaymentMethod.css";
import {
    useNavigate,
  Link,
  useLocation
} from "react-router-dom";

// ── Icons ──────────────────────────────────────────────────────────────
const Icons = {
  Dashboard: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </svg>
  ),
  Conversions: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  ),
  Payments: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="4" width="22" height="16" rx="2" />
      <line x1="1" y1="10" x2="23" y2="10" />
    </svg>
  ),
  Settings: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" />
      <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
    </svg>
  ),
  Help: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  ArrowLeft: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </svg>
  ),
  CreditCard: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="4" width="22" height="16" rx="2" />
      <line x1="1" y1="10" x2="23" y2="10" />
    </svg>
  ),
  Upi: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="5" y="2" width="14" height="20" rx="2" />
      <line x1="12" y1="18" x2="12.01" y2="18" />
    </svg>
  ),
  CheckCircle: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  Lock: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0110 0v4" />
    </svg>
  ),
  Refresh: () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" />
    </svg>
  ),
};

// ── Input Field ────────────────────────────────────────────────────────
function InputField({ label, placeholder, value, onChange, suffix, type = "text" }) {
  return (
    <div className="field">
      <label className="field__label">{label}</label>
      <div className="field__input-wrapper">
        <input
          type={type}
          className="field__input"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
        {suffix && <div className="field__suffix">{suffix}</div>}
      </div>
    </div>
  );
}

// ── Sidebar ────────────────────────────────────────────────────────────
function Sidebar() {

    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
                      localStorage.removeItem("currentUser");
                      localStorage.removeItem("selectedPlan");
                      navigate("/");
                    };

  const NAV_ITEMS = [
    { label: "Dashboard", icon: <Icons.Dashboard />, active: false ,path: "/dashboard" },
    { label: "Conversions", icon: <Icons.Conversions />, active: false ,path: "/conversions" },
    { label: "Payments", icon: <Icons.Payments />, active: true ,path: "/payments" },
    { label: "Settings", icon: <Icons.Settings />, active: false ,path: "/settings" },
    { label: "Help", icon: <Icons.Help />, active: false ,path: "/help" },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar__upper">
        <div className="sidebar__profile">
          <div className="sidebar__avatar">AS</div>
          <div>
            <div className="sidebar__name">ConvertPro</div>
            <div className="sidebar__role">Alex Sterling · Admin</div>
          </div>
        </div>

        <nav className="sidebar__nav">
          {NAV_ITEMS.map((item) => (
                                                                <Link
                                                                  key={item.label}
                                                                  to={item.path}
                                                                  className={`db-nav-item ${
                                                                    location.pathname === item.path
                                                                      ? "db-nav-item--active"
                                                                      : ""
                                                                  }`}
                                                                >
                                                                  <span className="db-nav-icon">
                                                                    {item.icon}
                                                                  </span>
                                                                  {item.label}
                                                                </Link>
                                                              ))}
      {/* ─── Logout separator + button ─── */}
                                                                                                                                    <div className="db-nav-separator" />
                                                                                                                                    <button className="db-nav-item db-nav-logout" onClick={handleLogout}>
                                                                                                                                      <span className="db-nav-icon">
                                                                                                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E24646" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                                                                                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                                                                                                                          <polyline points="16 17 21 12 16 7" />
                                                                                                                                          <line x1="21" y1="12" x2="9" y2="12" />
                                                                                                                                        </svg>
                                                                                                                                      </span>
                                                                                                                                      Log Out
                                                                                                                                    </button>
        </nav>
      </div>
    </aside>
  );
}

// ── Card Preview ───────────────────────────────────────────────────────
function CardPreview({ cardNumber, cardholderName, expiry }) {
  const formatted = cardNumber
    ? cardNumber.replace(/(.{4})/g, "$1 ").trim()
    : "•••• •••• •••• ••••";

  return (
    <div className="preview">
      <div className="preview__header">
        <h3 className="preview__title">Live Preview</h3>
        <p className="preview__subtitle">Updates as you type</p>
      </div>

      <div className="card-graphic">
        <div className="card-graphic__circle card-graphic__circle--top" />
        <div className="card-graphic__circle card-graphic__circle--bottom" />
        <div className="card-graphic__top-row">
          <span className="card-graphic__brand-name">ConvertPro</span>
          <span className="card-graphic__badge">VISA</span>
        </div>
        <div className="card-graphic__bottom">
          <div className="card-graphic__number">{formatted}</div>
          <div className="card-graphic__meta">
            <div>
              <div className="card-graphic__label">CARDHOLDER</div>
              <div className="card-graphic__value">{cardholderName || "Your Name"}</div>
            </div>
            <div className="card-graphic__meta-right">
              <div className="card-graphic__label">EXPIRES</div>
              <div className="card-graphic__value">{expiry || "MM/YY"}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="auto-sync">
        <span className="auto-sync__badge">
          <Icons.Refresh /> Auto-sync
        </span>
        <div className="auto-sync__line" />
      </div>

      <div className="security-badge">
        <div className="security-badge__icon"><Icons.Lock /></div>
        <div>
          <div className="security-badge__title">Secure Payment Gateway</div>
          <div className="security-badge__subtitle">SSL 256-bit encryption</div>
        </div>
      </div>

      <div className="trust">
        <div className="trust__heading">TRUST & SECURITY</div>
        {[
          "PCI-DSS compliant payment processing",
          "Auto-renewal is managed from your billing settings",
          "Card details are tokenized and never stored in plain text",
        ].map((text) => (
          <div key={text} className="trust__row">
            <Icons.CheckCircle />
            <span>{text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── UPI Preview ────────────────────────────────────────────────────────
function UpiPreview({ upiId }) {
  return (
    <div className="preview">
      <div className="preview__header">
        <h3 className="preview__title">Live Preview</h3>
        <p className="preview__subtitle">Updates as you type</p>
      </div>

      <div className="card-graphic card-graphic--upi">
        <div className="card-graphic__circle card-graphic__circle--top" />
        <div className="card-graphic__top-row">
          <span className="card-graphic__brand-name">UPI Pay</span>
          <span className="card-graphic__badge card-graphic__badge--upi">UPI</span>
        </div>
        <div className="card-graphic__upi-icon-wrapper">
          <div className="card-graphic__upi-icon">
            <Icons.Upi />
          </div>
        </div>
        <div className="card-graphic__upi-bottom">
          <span className="card-graphic__upi-id">{upiId || "yourname@upi"}</span>
          <span className="card-graphic__upi-status">ACTIVE</span>
        </div>
      </div>

      <div className="auto-sync">
        <span className="auto-sync__badge">
          <Icons.Refresh /> Auto-sync
        </span>
        <div className="auto-sync__line" />
      </div>

      <div className="upi-apps">
        <div className="upi-apps__title">Supported UPI Apps</div>
        <div className="upi-apps__grid">
          {[
            { name: "Google Pay", color: "#4285F4", letter: "G" },
            { name: "PhonePe", color: "#5F259F", letter: "P" },
            { name: "Paytm", color: "#00BAF2", letter: "P" },
            { name: "BHIM", color: "#E53935", letter: "B" },
          ].map((app) => (
            <div key={app.name} className="upi-apps__chip">
              <span className="upi-apps__icon" style={{ backgroundColor: app.color }}>
                {app.letter}
              </span>
              <span>{app.name}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="how-it-works">
        <div className="how-it-works__title">How it works</div>
        {["Enter your UPI ID", "Verify on your UPI app", "Payment linked automatically"].map(
          (step, i) => (
            <div key={step} className="how-it-works__step">
              <span className="how-it-works__number">{i + 1}</span>
              <span>{step}</span>
            </div>
          )
        )}
      </div>

      <div className="security-badge">
        <div className="security-badge__icon"><Icons.Lock /></div>
        <div>
          <div className="security-badge__title">Secure Payment Gateway</div>
          <div className="security-badge__subtitle">SSL 256-bit encryption</div>
        </div>
      </div>
    </div>
  );
}

// ── Main Page ──────────────────────────────────────────────────────────
export default function AddPaymentMethod() {
    const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("card");
  const [cardNumber, setCardNumber] = useState("");
  const [expiry, setExpiry] = useState("");
  const [cvv, setCvv] = useState("");
  const [cardholderName, setCardholderName] = useState("");
  const [streetAddress, setStreetAddress] = useState("");
  const [city, setCity] = useState("");
  const [stateRegion, setStateRegion] = useState("");
  const [zip, setZip] = useState("");
  const [upiId, setUpiId] = useState("");
  const [isDefault, setIsDefault] = useState(false);
  const API_URL =
    process.env.REACT_APP_API_URL;

  const handleAddPaymentMethod = async () => {
    try {

      const currentUser = JSON.parse(
        localStorage.getItem("currentUser")
      );

      const cardLast4 =cardNumber.replace(/\s/g, "").slice(-4);

      let cardBrand = "UNKNOWN";

      if (cardNumber.startsWith("4")) {
        cardBrand = "VISA";
      }
      else if (
        cardNumber.startsWith("5")
      ) {
        cardBrand = "MASTERCARD";
      }
      else if (
        cardNumber.startsWith("34") ||
        cardNumber.startsWith("37")
      ) {
        cardBrand = "AMEX";
      }

      const methodName =
        activeTab === "card"
          ? `${cardBrand} ending in ${cardLast4}`
          : upiId;


      const response = await fetch(
        `${API_URL}/payment-methods`,
        {
          method: "POST",

          headers: {
            "Content-Type":
              "application/json",
          },

          body: JSON.stringify({
            user_id:
              currentUser.user_id,

            payment_type:
              activeTab === "card"
                ? "CARD"
                : "UPI",

            method_name:methodName,

            card_holder_name:
              cardholderName,

            card_brand: cardBrand,

            card_last4:
                cardLast4,

            card_number:
              cardNumber,

            expiry_month:
              expiry.split("/")[0],

            expiry_year:
              expiry.split("/")[1],

            upi_id:

              activeTab === "upi"
                ? upiId
                : null,

            street_address:
              streetAddress,

            city,

            state_region:
              stateRegion,

            postal_code:
              zip,

            is_default:
              isDefault,
          }),
        }
      );

      const result =
        await response.json();

      alert(result.message);
      navigate("/payments");

    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="page">
      <Sidebar />

      <main className="main">
        {/* Header */}
        <div className="page-header">
          <div>
            <h1 className="page-header__title">Add Payment Method</h1>
            <p className="page-header__subtitle">
              {activeTab === "card"
                ? "Enter your credit card details and billing address below"
                : "Enter your UPI ID below to continue"}
            </p>
          </div>
          <Link
            to="/payments"
            className="page-header__back"
          >
            <Icons.ArrowLeft />
            Back to Payments
          </Link>
        </div>

        {/* Content */}
        <div className="content-grid">
          <div className="form-card">
            {/* Tab selector */}
            <div className="tab-selector">
              <button
                className={`tab-selector__tab ${activeTab === "card" ? "tab-selector__tab--card-active" : ""}`}
                onClick={() => setActiveTab("card")}
              >
                <Icons.CreditCard />
                Credit/Debit Card
              </button>
              <button
                className={`tab-selector__tab ${activeTab === "upi" ? "tab-selector__tab--upi-active" : ""}`}
                onClick={() => setActiveTab("upi")}
              >
                <Icons.Upi />
                UPI
              </button>
            </div>

            {/* Card form */}
            {activeTab === "card" && (
              <>
                <div className="form-section">
                  <h3 className="form-section__title">Card Information</h3>
                  <p className="form-section__subtitle">
                    We support major secure credit and debit cards globally
                  </p>
                </div>
                <div className="form-fields">
                  <InputField
                    label="Card Number"
                    placeholder="4242 4242 4242 4242"
                    value={cardNumber}
                    onChange={(e) => setCardNumber(e.target.value)}
                    suffix={
                      <>
                        <span className="brand-chip brand-chip--visa">VISA</span>
                        <span className="brand-chip brand-chip--mc">MC</span>
                        <span className="brand-chip brand-chip--amex">AMEX</span>
                      </>
                    }
                  />
                  <div className="form-fields__row">
                    <InputField
                      label="Expiration Date"
                      placeholder="MM / YY"
                      value={expiry}
                      onChange={(e) => setExpiry(e.target.value)}
                    />
                    <InputField
                      label="CVV"
                      placeholder="•••"
                      type="password"
                      value={cvv}
                      onChange={(e) => setCvv(e.target.value)}
                    />
                  </div>
                  <InputField
                    label="Cardholder Name"
                    placeholder="Alex Sterling"
                    value={cardholderName}
                    onChange={(e) => setCardholderName(e.target.value)}
                  />
                </div>
              </>
            )}

            {/* UPI form */}
            {activeTab === "upi" && (
              <>
                <div className="form-section">
                  <h3 className="form-section__title">UPI Details</h3>
                  <p className="form-section__subtitle">
                    Use your registered UPI ID to link your account
                  </p>
                </div>
                <div className="form-fields">
                  <InputField
                    label="UPI ID"
                    placeholder="yourname@upi"
                    value={upiId}
                    onChange={(e) => setUpiId(e.target.value)}
                  />
                  <p className="form-fields__note">
                    Supported UPI apps include Google Pay, PhonePe, Paytm, BHIM,
                    and other UPI-enabled wallets.
                  </p>
                </div>
              </>
            )}

            <div className="form-card__divider" />

            {/* Billing address (shared) */}
            <div className="form-section">
              <h3 className="form-section__title">Billing Address</h3>
              <p className="form-section__subtitle">
                Provide details associated with your card issuing account
              </p>
            </div>
            <div className="form-fields">
              <InputField
                label="Street Address"
                placeholder="1234 Innovation Blvd"
                value={streetAddress}
                onChange={(e) => setStreetAddress(e.target.value)}
              />
              <div className="form-fields__row form-fields__row--three">
                <InputField label="City" placeholder="San Francisco" value={city} onChange={(e) => setCity(e.target.value)} />
                <InputField label="State / Region" placeholder="California" value={stateRegion} onChange={(e) => setStateRegion(e.target.value)} />
                <InputField label="ZIP / Postal Code" placeholder="94102" value={zip} onChange={(e) => setZip(e.target.value)} />
              </div>
            </div>

            {/* Default checkbox */}
            <label className="checkbox">
              <input
                type="checkbox"
                checked={isDefault}
                onChange={(e) => setIsDefault(e.target.checked)}
              />
              <span>Set as default payment method</span>
            </label>

            {/* Actions */}
            <div className="form-actions">
              <button
                className="btn btn--cancel"
                onClick={() => navigate("/payments")}
              >
                Cancel
              </button>
              <button
                className="btn btn--primary"
                onClick={handleAddPaymentMethod}
              >
                Add Payment Method
              </button>
            </div>
          </div>

          {/* Preview sidebar */}
          {activeTab === "card" ? (
            <CardPreview cardNumber={cardNumber} cardholderName={cardholderName} expiry={expiry} />
          ) : (
            <UpiPreview upiId={upiId} />
          )}
        </div>
      </main>
    </div>
  );
}
